import axios from "axios";
import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

import domains from "./domains";
import widgets from "./widgets";

export default new Vuex.Store({
  state: {
    token: localStorage.getItem("user-token") || "",
    status: "",
    user: {},
  },
  mutations: {
    AUTH_REQUEST: (state) => {
      state.status = "loading";
    },
    AUTH_SUCCESS: (state, user) => {
      state.status = "success";
      state.token = user.token;
      state.user = user;
      try {
        window.Tawk_API = window.Tawk_API || {};
        window.Tawk_API.setAttributes(
          {
            name: user.firstName + " " + user.lastName,
            email: user.email,
          },
          function(error) {
            error;
          }
        );
      } catch (ex) {
        ex;
      }
      localStorage.setItem("user-token", user.token); // store the token in localstorage
    },
    AUTH_LOGOUT: (state) => {
      state.status = "success";
      state.token = "";
    },
    AUTH_ERROR: (state) => {
      state.status = "error";
    },
    OFFER_UPGRADED: (state, data) => {
      state.user.offer = data.offer;
      state.user.subscriptionValidUntil = data.subscriptionValidUntil;
    },
  },
  getters: {
    isAuthenticated: (state) => !!state.token,
    authStatus: (state) => state.status,
  },
  actions: {
    AUTH_INFOS: ({ commit, state }) => {
      return new Promise((resolve, reject) => {
        // The Promise used for router redirect in login
        commit("AUTH_REQUEST");
        axios({
          url: "https://www.eikyo.pro/api/getAccount",
          data: {
            token: state.token,
          },
          method: "POST",
        })
          .then((resp) => {
            if (resp.data.payload.Table == undefined) {
              commit("AUTH_ERROR", state.token);
              reject();
              return;
            }
            const user = resp.data.payload.Table[0];
            commit("AUTH_SUCCESS", user);
            resolve(user);
          })
          .catch((err) => {
            commit("AUTH_ERROR", err);
            localStorage.removeItem("user-token"); // if the request fails, remove any possible user token if possible
            reject(err);
          });
      });
    },
    AUTH_REQUEST: ({ commit, dispatch }, data) => {
      return new Promise((resolve, reject) => {
        // The Promise used for router redirect in login
        commit("AUTH_REQUEST");
        axios({
          url: "https://www.eikyo.pro/api/login",
          data: {
            email: data.email,
            password: data.password,
          },
          method: "POST",
        })
          .then((resp) => {
            if (resp.data.payload.Table == undefined) {
              commit("AUTH_ERROR", "KO");
              reject();
              return;
            }
            const user = resp.data.payload.Table[0];
            commit("AUTH_SUCCESS", user);
            // you have your token, now log in your user :)
            dispatch("AUTH_INFOS").then(() => {
              console.log("ok");
              resolve(resp);
            });
          })
          .catch((err) => {
            commit("AUTH_ERROR", err);
            localStorage.removeItem("user-token"); // if the request fails, remove any possible user token if possible
            reject(err);
          });
      });
    },
    AUTH_CREATE: ({ dispatch, commit }, data) => {
      return new Promise((resolve, reject) => {
        // The Promise used for router redirect in login
        commit("AUTH_REQUEST");
        axios({
          url: "https://www.eikyo.pro/api/createAccount",
          data: {
            email: data.email,
            password: data.password,
            firstName: data.firstName,
            lastName: data.lastName,
          },
          method: "POST",
        })
          .then((resp) => {
            if (resp.data.payload.Table == undefined) {
              commit("AUTH_ERROR", "KO");
              reject();
              return;
            }
            const user = resp.data.payload.Table[0];
            commit("AUTH_SUCCESS", user);
            // you have your token, now log in your user :)
            dispatch("AUTH_INFOS").then(() => {
              resolve(resp);
            });
          })
          .catch((err) => {
            commit("AUTH_ERROR", err);
            localStorage.removeItem("user-token"); // if the request fails, remove any possible user token if possible
            reject(err);
          });
      });
    },
    AUTH_UPDATE: ({ commit, state }, data) => {
      return new Promise((resolve, reject) => {
        // The Promise used for router redirect in login
        commit("AUTH_REQUEST");
        axios({
          url: "https://www.eikyo.pro/api/updateAccount",
          data: {
            email: data.email,
            password: data.password,
            firstName: data.firstName,
            lastName: data.lastName,
            token: state.token,
          },
          method: "POST",
        })
          .then((resp) => {
            if (resp.data.payload.affectedRows != "1") {
              commit("AUTH_ERROR", state.token);
              reject();
              return;
            }
            commit("AUTH_SUCCESS", { token: state.token });
            resolve(resp);
          })
          .catch((err) => {
            commit("AUTH_ERROR", err);
            localStorage.removeItem("user-token"); // if the request fails, remove any possible user token if possible
            reject(err);
          });
      });
    },
    AUTH_LOGOUT: ({ commit }) => {
      return new Promise((resolve) => {
        commit("AUTH_LOGOUT");
        localStorage.removeItem("user-token"); // clear your user's token from localstorage
        resolve();
      });
    },
    OFFER_UPGRADE: ({ state }, data) => {
      return new Promise((resolve, reject) => {
        axios({
          url: "https://www.eikyo.pro/api/payment/createSession",
          data: {
            plan: data.plan,
            period: data.period,
            token: state.token,
            dev: window.location.href.indexOf("dev=1") != -1 ? "1" : "0",
          },
          method: "POST",
        })
          .then((resp) => {
            resolve(resp.data.payload);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    REDEEM_CODE: ({ state, commit }, data) => {
      return new Promise((resolve, reject) => {
        axios({
          url: "https://www.eikyo.pro/api/payment/redeemAppSumoCode",
          data: {
            code: data.code,
            token: state.token,
          },
          method: "POST",
        })
          .then((resp) => {
            if (resp.data.payload.status === "OK") {
              commit("OFFER_UPGRADED", resp.data.payload);
            }
            resolve(resp.data.payload);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    OFFERS_LIST: () => {
      return new Promise((resolve, reject) => {
        axios({
          url: "https://www.eikyo.pro/api/payment/getOffers",
          data: {},
          method: "POST",
        })
          .then((resp) => {
            resolve(resp.data.Table);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
  modules: {
    domains,
    widgets,
  },
});
